import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { css } from "styled-components";

savedOrderListFilterStyles.datesGridItem = {
    css: css`
        padding: 15px;
    `,
    width: [12, 12, 6, 6, 4],
};

savedOrderListFilterStyles.fromGridItem = { width: [12, 6, 6, 6, 6] };
savedOrderListFilterStyles.toGridItem = { width: [12, 6, 6, 6, 6] };

savedOrderListFilterStyles.orderTotalGridItem = {
    css: css`
        padding: 15px;
    `,
    width: [12, 12, 6, 6, 4],
};
savedOrderListFilterStyles.orderTotalOperatorGridItem = { width: [12, 6, 6, 6, 6] };
savedOrderListFilterStyles.orderTotalAmountGridItem = { width: [12, 6, 6, 6, 6] };
savedOrderListFilterStyles.orderTotalAmountTextField = {
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 27px;
        `,
    },
};
savedOrderListFilterStyles.heading = {
    color: "primary",
    size: 20,
    fontFamily: "LibreBaskerville",
};
